import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { faTrashCan } from '@fortawesome/free-solid-svg-icons';
import { IAuctionDTO } from '../../../../models/IAuctionsDTO';
import { MyAuctionsService } from '../../../../services/bidder-community/my-auctions/my-auctions.service';
import { ToastMessageService } from '../../../../services/toast-message/toast-message.service';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-auction-item',
  imports: [FaIconComponent, DatePipe],
  templateUrl: './auction-item.component.html',
  styleUrl: './auction-item.component.scss'
})
export class AuctionItemComponent {

  private readonly myAuctionsService = inject(MyAuctionsService);
  private readonly messageService = inject(ToastMessageService); 

  faTrashCan = faTrashCan;

  @Output() getMyAuctionsList: EventEmitter<void> = new EventEmitter();

  @Input() auction:IAuctionDTO | null = null;

  getTimeLeftUntilAuctionOnlineCloseDate(auction:IAuctionDTO){
    const targetDate = new Date(auction.onlineCloseDate);
    const now = new Date();
    return this.daysHoursMinutes(targetDate.getTime() - now.getTime());
  }

  daysHoursMinutes (ms:number) {
    if(ms <= 0){
      return "Closed";
    }
    const days = Math.floor(ms / (24*60*60*1000));
    const daysms = ms % (24*60*60*1000);
    const hours = Math.floor(daysms / (60*60*1000));
    return days + "d " + hours + "h left";
  }

  onDelete(auction: IAuctionDTO){
    this.myAuctionsService.deleteAuction(auction.auctionId).subscribe(({
      next: (result) => {
        this.messageService.success(`Auction deleted successfully`);
        this.getMyAuctionsList.emit();
      },
      error: (err) => {
        this.messageService.error(err || 'unknown error');
      }
    }))
  }


}
